/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * PopulateEMR
 * OpenAPI spec version: v1
 */

export type PCCDashboardProgramStatus = typeof PCCDashboardProgramStatus[keyof typeof PCCDashboardProgramStatus];


export const PCCDashboardProgramStatus = {
  NotEligible: 'NotEligible',
  Eligible: 'Eligible',
  Enrolled: 'Enrolled',
  Completed20Minutes: 'Completed20Minutes',
  MinutesRemaining: 'MinutesRemaining',
  Pending: 'Pending',
  PendingDay1: 'PendingDay1',
  PendingDay2: 'PendingDay2',
  Complete: 'Complete',
} as const;
